export const PRODUCTION_HOST = 'bluedolphin.app';
export const PRODUCTION_KEY = 'production';
export const USER_ROLE = 'userRole';
export const IKEY_DEVELOPMENT = 'd199507b-2908-48f4-b546-8320c893ee61';
export const IKEY_PRODUCTION = 'dcde5dce-2be3-4d88-875a-81f6f9eacb66';
export const TENANT_KEY = 'tenant';
export const FRONTEND_KEY = 'FrontEnd';
export const ENV_KEY = 'env';
export const TENANT_NAME_KEY = 'tenantName';
export const CLOUD_ROLE_NAME_KEY = 'cloud_RoleName';
export const ACCOUNT_KEY = 'account';
export const FORCELOGIN_KEY = 'forcelogin';
export const AUTH_TENANT_KEY = 'authTenant';
export const ACCOUNTS_KEY = 'accounts';
export const URL_PATH = 'path';
export const STORAGE_WHITE_LIST = [
    'devtools',
    'import-map-override:react',
    'import-map-override:react-dom',
    'import-map-override:@bluedolphin/root-config',
    'import-map-override:@bluedolphin/auth-mf',
    'import-map-override:@bluedolphin/util-module-mf',
    'import-map-override:bluedolphin/css-vendor',
    'import-map-override:bluedolphin/css-bluedolphin',
    'import-map-override:bluedolphin/js-vendor',
    'import-map-override:bluedolphin/js-bluedolphin',
    'import-map-override:bluedolphin/ui',
    'import-map-override:bluedolphin/navbar-mf',
    'import-map-override:@bluedolphin/bpmn',
    'import-map-override:@bluedolphin/solution-design',
    'import-map-override:@bluedolphin/modeler',
    'import-map-override:api_url',
];
